module.exports = __webpack_public_path__ + "55152715646dafa4e1aacbb184effc9b.png";